export enum BusinessMergeEventStatus {
  ERROR = "ERROR",
  MERGED = "MERGED",
  PENDING_MERGE = "PENDING_MERGE",
  PENDING_UNMERGE = "PENDING_UNMERGE",
  UNMERGED = "UNMERGED",
}
